import { css } from 'aphrodite';
import * as React from 'react';
import { FC, ReactNode } from 'react';
import { Skeleton } from '../../../components-v2/Skeleton';
import { styleSheet } from './styles';

export const AgentRow: FC<{
	icon: ReactNode;
	title: ReactNode;
	detail: ReactNode;
	action: ReactNode;
}> = ({ icon, title, detail, action }) => (
	<div className={css(styleSheet.agentRow)}>
		{icon}
		<div className={css(styleSheet.rowBody)}>
			<span className={css(styleSheet.rowTitle)}>{title}</span>
			<span className={css(styleSheet.rowDetail)}>{detail}</span>
		</div>
		<span className={css(styleSheet.rowAction)}>{action}</span>
	</div>
);

export const AgentRowIcon = ({ styles = [], ...props }: AphroditeStyled<React.ComponentProps<'span'>>) => {
	return <span className={css(styleSheet.rowIcon, ...styles)} {...props} />;
};

export const AgentRowSkeleton: FC = () => (
	<div className={css(styleSheet.agentRow)}>
		<Skeleton styles={[styleSheet.skeletonIcon]} />
		<div className={css(styleSheet.rowBody)}>
			<Skeleton styles={[styleSheet.skeletonTitle]} />
			<Skeleton styles={[styleSheet.skeletonDetail]} />
		</div>
	</div>
);
